import Header from 'components/Header'
import DayWidgetSkeleton from 'components/DayWidgetSkeleton'
import { BannerSkeleton } from 'components/BannerSkeleton'
import { Column } from 'components/Flex'

import { Grid, GridItem } from '@interco/inter-ui/components/Grid'
import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import * as S from '../styles'

export const LoadingView = () => (
  <S.Wrapper>
    <Header title="Check-in premiado" />
    <S.Sections data-testid="skeleton-section">
      <S.Section>
        <Column $gap="8px" $alignItems="start">
          <Skeleton animation="pulse" width="212px" height="29px" style={{ borderRadius: '4px' }} />
          <Skeleton animation="pulse" width="264px" height="17px" style={{ borderRadius: '4px' }} />
          <Skeleton animation="pulse" width="73px" height="17px" style={{ borderRadius: '4px' }} />
        </Column>

        <Grid templateColumns="2fr 2fr" gap="16px" style={{ width: '100%' }}>
          <DayWidgetSkeleton />
          <DayWidgetSkeleton />
          <DayWidgetSkeleton />
          <DayWidgetSkeleton />
          <DayWidgetSkeleton />
          <DayWidgetSkeleton />
          <GridItem column="span 2">
            <DayWidgetSkeleton />
          </GridItem>
        </Grid>
      </S.Section>

      <S.Divider />

      <S.Section>
        <BannerSkeleton />
      </S.Section>
    </S.Sections>
  </S.Wrapper>
)

export default LoadingView
